import { useTranslation } from "react-i18next";
import ToolboxDetailHeader from "../ToolboxDetailHeader";
import Box from "@mui/material/Box";
import PreferenceWidgets from "./components/PreferenceWidgets";

const Preferences = () => {
  const { t } = useTranslation("flowDesigner");

  return (
    <Box py={2} pl={2} pr={1} sx={{ flexGrow: 1 }}>
      <ToolboxDetailHeader title={t("toolbox.headers.preferences")} />
      <Box
        pr={2}
        sx={{ overflow: "hidden", overflowY: "auto", height: "auto", scrollbarWidth: "thin" }}
      >
        <PreferenceWidgets />
      </Box>
    </Box>
  );
};

export default Preferences;
